import { useEffect, useState } from 'react';
import NudosSearchbarDropdown from '../NudosSearchbarDropdown/NudosSearchbarDropdown';
import errorMessage from '../../../utils/errorMessage';
import { getAdditionalServiceNotCompleteReasonOptions } from '../../../services/services';
import {
  IadditionalServiceNotCompleteReason,
  LS_ADDITIONAL_SERVICE_NOT_COMPLETE_REASON
} from '../../../types/product.configuration.types';
import './AdditionalServiceNotCompleteReasonsDropdown.scss';

const AdditionalServiceNotCompleteReasonsDropdown = ({
  clickSelectOptionCallback,
  currentValue,
  initialReasonId,
  isConfiguration
}: {
  currentValue?: IadditionalServiceNotCompleteReason;
  clickSelectOptionCallback: (clickedOption: IadditionalServiceNotCompleteReason) => void;
  initialReasonId?: number;
  isConfiguration?: boolean;
}) => {
  const [dropdownOptions, setDropdownOptions] = useState<IadditionalServiceNotCompleteReason[]>([]);
  const [loadingOptions, setLoadingOptions] = useState(false);

  const otherReason = LS_ADDITIONAL_SERVICE_NOT_COMPLETE_REASON.OTHER;

  const formDropdownOptionsCallback = (
    rawOptions: IadditionalServiceNotCompleteReason[],
    clickOptionCallback?: (option: IadditionalServiceNotCompleteReason) => void
  ) => {
    return rawOptions.map((option, i) => {
      const handleSelectOption = () => {
        clickSelectOptionCallback(option);
        clickOptionCallback && clickOptionCallback(option);
      };
      return (
        <div className="optionContainer notCompleteOption" key={`option${option?.id}${i}`} onClick={handleSelectOption}>
          {option?.name}
        </div>
      );
    });
  };

  const formSelectedOptionUICallback = (rawSelectedOption: IadditionalServiceNotCompleteReason) => {
    return <div className="selectedOption">{rawSelectedOption?.name}</div>;
  };

  const filterBySearchStringCallback = (search: string, rawOptions: IadditionalServiceNotCompleteReason[]) => {
    return rawOptions.filter(option => {
      return option?.name?.toLowerCase().trim().includes(search.toLowerCase().trim());
    });
  };

  const getDropdownOptions = async () => {
    setLoadingOptions(true);
    try {
      const options = await getAdditionalServiceNotCompleteReasonOptions();
      if (!isConfiguration) setDropdownOptions(options);
      const filteredOptions = options.filter(option => option.name === otherReason);
      const findOthers = options.find(option => option.name === otherReason);
      if (isConfiguration) setDropdownOptions(filteredOptions);
      if (findOthers && isConfiguration) clickSelectOptionCallback?.(findOthers);
    } catch (error) {
      errorMessage();
    } finally {
      setLoadingOptions(false);
    }
  };

  useEffect(() => {
    getDropdownOptions();
  }, []);

  useEffect(() => {
    if (currentValue?.id) return;
    const initialReason = dropdownOptions.find(option => option?.id === initialReasonId);
    if (!initialReason) return;
    clickSelectOptionCallback(initialReason);
  }, [initialReasonId, dropdownOptions?.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="additionalServiceNotCompleteReasonsDropdown">
      <NudosSearchbarDropdown
        customClassname="notCompletedeasonsDropdown"
        label="Indica por qué no se pudo completar"
        componentSize="medium"
        customPlaceholder="Selecciona el motivo"
        isFilled={!!currentValue}
        currentValue={currentValue}
        includeMagnifierIcon={false}
        rawOptions={dropdownOptions}
        formDropdownOptionsCallback={formDropdownOptionsCallback}
        formSelectedOptionUICallback={formSelectedOptionUICallback}
        filterBySearchStringCallback={filterBySearchStringCallback}
        closesOnChangeSelection
        showSkeletonLoader={loadingOptions}
      />
    </div>
  );
};

export default AdditionalServiceNotCompleteReasonsDropdown;
